import { constants } from "../../misc/constants";
import Scenario2 from "./Scenario2";
import { TransformUIConfig } from "../../components/ui/TransformUI";
import MedsurgBaseScenarioPart from "../MedsurgBaseScenarioPart";
import { Window508Type } from "../MedsurgBaseScenario";

export default class Scenario2Part1 extends MedsurgBaseScenarioPart {

	chapterIds = {
		chapterCinematic1: 'medsurg-cinematic-2-1',
        chapterCinematic2: 'medsurg-cinematic-2-2', //CAN BE REPLACED
        chapterCinematic3: 'medsurg-cinematic-2-3',
        chapterCinematic4: 'medsurg-cinematic-2-4',
        chapterCinematic5: 'medsurg-cinematic-2-5',
	}

	constructor(scenario: Scenario2, private onDone: () => void){
		super(scenario);
	}

	private PrInstanceID: string;
	private TalkInstanceID1: string;
	private ActionInstanceID1: string;
	private RememberDisplayed: boolean = false;
	private ActionInstanceID2: string;
	private MoveInstanceID: string;

	private Talk1: boolean = false;
	private Talk2: boolean = false;
	private Action1: boolean = false;
	private Action11: boolean = false;
	private Action12: boolean = false;
	private Action13: boolean = false;
	private Action14: boolean = false;
	private Action15: boolean = false;

	private TalkCount: number = 0;
	private OldTalkCount: number = 0;
	private ActionCount: number = 0;
	private OldActionCount: number = 0;

	public get videoUrl(): string[] {
		//return ['./assets/videos/scenario2/video3' + this.scenario.avatarIndx + '.mp4'];
		return ['./assets/videos/scenario2/video30.mp4'];
	}

	public get partId(): string {
		return constants.scenarios.scenario2.parts.level2Part1.id;
	}

	public start() {
		const context = this;
		this.RememberDisplayed = false;

		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).rothVitalsID, {
			title: 'Vitals - On Admission'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).rothVitalsID, {
			list: '<li>Temperature: 99.8</li>',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).rothVitalsID, {
			list: '<li>Pulse: 90</li>',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).rothVitalsID, {
			list: '<li>Respirations: 20</li>',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).rothVitalsID, {
			list: '<li>Blood Pressure: 118/76</li>',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).rothVitalsID, {
			list: '<li>Oxygen Saturation: 95% supplemental O2 (2L/hr)</li>',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).rothVitalsID, {
			title: 'Vitals - 09:00',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).rothNursesID, {
			visit: context.scenario.visit1,
			lineBreak: true,
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).rothBasicID, {
			title: 'Patient Information',
			description: '<ul style=\"list-style-type:square\"><li>Joe Roth, a 44-year-old active adult male weighing 175 lbs. (80 kg), presented at the ED with shortness of breath and fatigue, and was diagnosed with pneumonia. He was admitted to the MS unit. He has complaints of increased respirations and experiencing shortness of breath for three days. He also has complaints of feeling tired. He is scheduled for diagnostics tests in the morning.</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).rothBasicID, {
			title: 'Patient History',
			description: '<ul style=\"list-style-type:square\"><li>No known allergies</li><li>Left lower lobe pneumonia confirmed via chest x-ray</li><li>Caucasian</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).rothBasicID, {
			title: 'Active Medications',
			description: '<ul style=\"list-style-type:square\"><li>NA</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).rothBasicID, {
			title: 'Providers Orders',
			description: '<ul style=\"list-style-type:square\"><li>Supplemental O2 - 2L via nasal cannula</li><li>Piperacillin and Tazpbactam - 3.375 grams every 6 hours</li><li>Normal saline - 100 mL/hr</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).rothBasicID, {
			title: 'Dietary Restrictions',
			description: '<ul style=\"list-style-type:square\"><li>NA</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).rothBasicID, {
			title: 'Other Observations',
			description: '<ul style=\"list-style-type:square\"><li>NA</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).rothBasicID, {
			title: 'Post-Op Information',
			description: '<ul style=\"list-style-type:square\"><li>NA</li></ul>'
		});

        this.scenario.displayBeginScenarioUI(
            './assets/images/scenario2/begin-scenario-scenario2.jpg', 
            'start2', 
			2,
            () => {
                context.segment1Step1IntroWalking();
		});
		//TO BE RE-ADDED WHEN DONE
		//context.segment1Step1IntroWalking();
	}

	private segment1Step1IntroWalking() {
		var context = this;
		this.scenario.destroyAllUIInstances();
		context.scenario.displayHeader();
		this.scenario.playAmbientLoop(this.scenario.audioHall);
		this.playVideoChapter(this.chapterIds.chapterCinematic1, () => {
			context.segment1Step2ContinueRoom1();
		});
    }


	private segment1Step4Remember() {
		var context = this;
		this.scenario.update508Window(Window508Type.Remember);
		this.scenario.displayRemember(() => {
			this.scenario.update508Window(Window508Type.Main);
			this.RememberDisplayed = true;
			context.scenario.destroyAllUIInstances();
			// context.skipPart();
		});
	}
	//use when skipping part for testing
	private skipPart() {
		var context = this;
		context.scenario.hideFooter();
		this.scenario.displayModalPop(
			null,
            'Skipping to part 2',
            () => {
                context.scenario.destroyAllUIInstances();
                    context.segment1StepFinal();
            }
        );
	}

    private segment1Step2ContinueRoom1() {
		this.scenario.destroyAllUIInstances();
        var context = this;
        context.scenario.gameManager.environment.blurFadeIn();
        this.scenario.displayModalPop(
			null,
            'You have a new patient to visit in room 4',
            () => {
				this.scenario.stopAmbientLoop();
				this.scenario.playAmbientLoop(this.scenario.audioRoom);
				context.scenario.destroyAllUIInstances();
				this.scenario.gameManager.environment.blurFadeOut();
				this.playVideoChapter(this.chapterIds.chapterCinematic3, () => {}, true);
                context.PreloadUis();
				if(this.RememberDisplayed === false) {
					context.segment1Step4Remember();
				}
				context.scenario.displayFooter(() => this.PrInstanceID, () => this.TalkInstanceID1, () => this.ActionInstanceID1, '2', '1', false, false);
				context.TalkCount = 2;
				context.ActionCount = 1;
				context.getFooterCounts();
            }
        );
    }

	private segment1Part5Debrief() {
		var context = this;
		context.scenario.displayDebrief(1250, () => {
			localStorage.setItem('ignoreResumePopup', 'true');
			window.location.reload();
		}, () => {
			context.segment1StepFinal();
		});
	}

	private segment1StepFinal() {
        var context = this;
        context.scenario.destroyAllUIInstances();
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).rothVitalsID, {
			title: 'Vitals - 12:00',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).rothNursesID, {
			visit: context.scenario.visit2,
			lineBreak: true,
		});
    	context.partEnd();
    }

	private partEnd() {
        var context = this;
		this.scenario.gameManager.customData.saveData.scenarios[context.scenario.currentLevel].lastPartId = this.partId;
		this.scenario.stopAmbientLoop();
		context.scenario.saveScore();
		context.onDone();

		//this.scenario.showBadgingUI(0, () => {
        //    context.onDone();
        //});
	}

    public PreloadUis(shouldHidePatientRecord?: boolean) {
        var context = this;
        this.PrInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.PatientRecordUI, {
            top: [
				{
					description: 'Name: Joe Roth'
				},
				{
					description: 'Room: #4'
				},
				{
					description: 'Age: 44'
				},
				{
					description: 'Sex: Male'
				}
			],
			basic: this.scenario.getScenarioDataEntryItems((this.scenario as Scenario2).rothBasicID),
			nurses: this.scenario.getScenarioDataEntryItems((this.scenario as Scenario2).rothNursesID),
			lab: [
				{
					title: 'Test Name',
					description1: 'Platelets',
					description2: '<div aria-label="200,000 m c L">200,000 mcL</div>',
					description3: '<div aria-label="150,000 to 400,000">150,000 - 400,000</div>'
				},
				{
					title: 'Results',
					description1: 'White Count',
					description2: '<div style="color: red" aria-label="14,000 m c L. up"> 14,000 mcL <span style="float: right">&#129137;</span></div>', // 7 change to 9 for down arrow
					description3: '<div aria-label="4,500 to 10,000">4,500 - 10,000</div>'
				},
				{
					title: 'Normal Range',
					description1: 'Lactate',
					description2: '<div style="color: red" aria-label="1.5 m m o l over L. up"> 1.5 mmol/L <span style="float: right">&#129137;</span></div>',
					description3: '<div aria-label="0.5 to 1">0.5 - 1</div>'
				},
				{
					description1: 'Blood Cultures',
					description2: '<div aria-label="Pending">Pending</div>',
					description3: '<div aria-label="Pending">Pending</div>'
				}
			],
			vitals: this.scenario.getScenarioDataEntryItems((this.scenario as Scenario2).rothVitalsID),
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.Remember);
				}, 500);
				this.scenario.gameManager.UiManager.hideUiInstance(this.PrInstanceID);
				// if(this.RememberDisplayed === false) {
				// 	context.segment1Step4Remember();
				// }
			}
		});

		if(shouldHidePatientRecord) {
			this.scenario.gameManager.UiManager.hideUiInstance(this.PrInstanceID);
		} else {
			setTimeout(() => {
				context.scenario.update508Window(Window508Type.PatientRecord);
			}, 500);
		}

		(this.scenario as Scenario2).PrRothID = this.PrInstanceID;

		context.TalkInstanceID1 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Talk',
			talks: [
				{
					toppx: '50px',
					titletext: 'How are you feeling?',
					onClicked: () => {
						this.segment1TalkFeeling();
					},
					disable: () => this.Talk1
				},
				{
					toppx: '150px',
					titletext: 'On a scale of 0-10, can you rate your pain?',
					onClicked: () => {
						this.segment1TalkRate();
					},
					disable: () => this.Talk2
				}
			],
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				this.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
			}
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);

		this.ActionInstanceID1 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Action',
			talks: [
				{
					toppx: '50px',
					titletext: 'Take Vitals',
					onClicked: () => {
						this.segment1ActionVitals();
					},
					disable: () => this.Action1
				}
			],
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
			}
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
	}

	private segment1ActionVitals() {
		var context = this;
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		this.ActionInstanceID2 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Take Vitals',
			talks: [
				{
					toppx: '50px',
					titletext: 'Temperature',
					onClicked: () => {
						context.segment1ActionTemperature();
					},
					disable: () => this.Action11
				},
				{
					toppx: '150px',
					titletext: 'Blood Pressure',
					onClicked: () => {
						context.segment1ActionBloodPressure();
					},
					disable: () => this.Action12
				},
				{
					toppx: '250px',
					titletext: 'Pulse',
					onClicked: () => {
						context.segment1ActionPulse();
					},
					disable: () => this.Action13
				},
				{
					toppx: '350px',
					titletext: 'Respirations',
					onClicked: () => {
						context.segment1ActionRespirations();
					},
					disable: () => this.Action14
				},
				{
					toppx: '450px',
					titletext: 'O2 Sat Level',
					onClicked: () => {
						context.segment1ActionSatLevel();
					},
					disable: () => this.Action15
				}
			],
			onClosed: () => {
				this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			}
		});
	}

	private segment1TalkFeeling() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '70px',
			loadQuiz: true,
			scenario: this,
			titletext: 'How are you feeling?',
			isTalks: true,
			extBottom: true,
			extText: "I'm so weak, and I just don't feel right. I had to go to the bathroom a while ago, and I was afraid I wasn't going to make it. I could hardly stand up.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).rothNursesID, {
					title: context.scenario.patientObservation,
				}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).rothNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.patientObservation)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.Talk1 = true;
				this.TalkCount = this.OldTalkCount - 1;
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 7,
					quiztop: '5px',
					maxPoints: 350,
					talktext1: 'Patient Observation',
					talktext2: 'General',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'No active problems',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Weak',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Nausea',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Trembling',
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Lethargic',
							onClicked: () => {
							},
						},
						{
							buttontop: '400px',
							buttontext: 'Chills',
							onClicked: () => {
							},
						},
						{
							buttontop: '450px',
							buttontext: "Doesn't feel right",
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				},
				{
					quizheight: 3,
					prequizheight: 7,
					quiztop: '520px',
					maxPoints: 200,
					talktext1: 'Patient Observation',
					talktext2: 'Advise patient how to get out of bed',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Walk slowly',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Hold onto furniture',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Use call button',
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic4, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic3, () => {}, true);
		});
	}

	private segment1TalkRate() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '170px',
			loadQuiz: true,
			titletext: 'On a scale of 0-10, can you rate your pain?',
			isTalks: true,
			isPainScale: true,
			scenario: this,
			painScaleMaxPoints: 200,
			painScaleCorrect: 0,
			extBottom: true,
			extText: "I really don't have any pain.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				this.scenario.evaluateScoreForPainScale(updatedConfig);
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).rothNursesID, {
					title: context.scenario.patientAssessment,
				}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).rothNursesID, {
					header: 'Pain Scale',
					list: '<li>'+updatedConfig.painAssessment+'</li>',
				}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.patientAssessment)
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.Talk2 = true;
				this.TalkCount = this.OldTalkCount - 1;
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic5, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic3, () => {}, true);
		});
	}

	private segment1ActionTemperature() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '70px',
			loadQuiz: true,
			titletext: 'Temperature',
			vitaltext: '100.8',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_temp.png',
			scenario: this,
			onSubmit: () => {
				this.Action11 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).rothVitalsID, {
					list: '<li>Temperature : 100.8</li>',
				})
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.updateScore(100);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionBloodPressure() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '170px',
			loadQuiz: true,
			titletext: 'Blood Pressure',
			scenario: this,
			vitaltext: '110/74',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_bp.png',
			onSubmit: () => {
				this.Action12 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).rothVitalsID, {
					list: '<li>Blood Pressure : 110/74</li>',
				})
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.updateScore(100);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionPulse() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '270px',
			loadQuiz: true,
			titletext: 'Pulse',
			vitaltext: '100',
			scenario: this,
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_pulse.png',
			onSubmit: () => {
				this.Action13 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).rothVitalsID, {
					list: '<li>Pulse : 100</li>',
				})
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.updateScore(100);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionRespirations() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '370px',
			loadQuiz: true,
			titletext: 'Respirations',
			vitaltext: '24',
			scenario: this,
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_respiration.png',
			onSubmit: () => {
				this.Action14 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).rothVitalsID, {
					list: '<li>Respirations : 24</li>',
				})
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.updateScore(100);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionSatLevel() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '470px',
			loadQuiz: true,
			titletext: 'O2 Sat Level',
			vitaltext: '93% 2L supplemental O2',
			scenario: this,
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_o2.png',
			onSubmit: () => {
				this.Action15 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).rothVitalsID, {
					list: '<li>02 Sat Level : 93% supplemental O2</li>',
				})
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.updateScore(100);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -400px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private getFooterCounts() {
		var context = this;
		this.OldTalkCount = this.TalkCount;
		this.OldActionCount = this.ActionCount;
		if(this.TalkCount === 0 && this.ActionCount === 0) {
			context.scenario.updateFooter('0', '0', true, true);
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			context.scenario.hideFooter();
			context.scenario.update508Window(Window508Type.Main);
			context.segment1Part5Debrief();
		}
		else if(this.TalkCount === 0 && this.ActionCount !== 0) {
			context.scenario.updateFooter('0', this.ActionCount.toString(), true, false);
			context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
			context.scenario.update508Window(Window508Type.Main);
		}
		else if(this.TalkCount !== 0 && this.ActionCount === 0) {
			context.scenario.updateFooter(this.TalkCount.toString(), '0', false, true);
			context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
			context.scenario.update508Window(Window508Type.Main);
		}
		else {
			context.scenario.updateFooter(this.TalkCount.toString(), this.ActionCount.toString(), false, false)
		};
	}

	private checkIfSubMenu() {
		var context = this;
		if(this.Action11 === true && this.Action12 === true && this.Action13 === true && this.Action14 === true && this.Action15 === true) {
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			this.ActionCount = this.OldActionCount - 1;
			this.Action1 = true;
		};
		context.getFooterCounts();
	}
}